/* @flow strict */

import * as React from 'react';
import { RoutesType } from 'client/src/routes';
import DBPage from './index';

export const DBRoutes: RoutesType = [{
  Component: DBPage,
  params: {
    path: '/customer-database'
  }
}];
